import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '100px 24px', animation: 'fadeIn 0.4s ease' }}>
      <div className="font-display" style={{ fontSize: 72, fontWeight: 900, color: '#00205B', lineHeight: 1, opacity: 0.15 }}>404</div>
      <h2 className="font-display" style={{ fontSize: 22, fontWeight: 800, color: '#00205B', margin: '8px 0' }}>Page Not Found</h2>
      <p className="empty-sub" style={{ marginBottom: 24 }}>The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/" className="btn-primary" style={{ display: 'inline-block' }}>Back to Home</Link>
    </div>
  );
}
